import { ICustomerDeliveryAddress, IDeliveryAddressShippingCost, IResponse } from "../common/interfaces";
import { request } from "./AjaxService";

const baseRoute = "customer/delivery-address";

export const DeliveryAddressService = {
  getByCustomer: async (
    customerId: number
  ): Promise<IResponse<ICustomerDeliveryAddress[]>> =>
    await request.get(`${baseRoute}/get`, { customerId: String(customerId) }),

  create: async (payload: {
    name: string;
    address: string;
    number?: string;
    lat?: number;
    lng?: number;
    customer_id: number;
  }): Promise<IResponse<ICustomerDeliveryAddress>> =>
    await request.post(baseRoute, payload),

  upsertShippingCost: async (
    addressId: number,
    payload: { warehouse_id: number; shipping_cost: number; distance_meters?: number }
  ): Promise<IResponse<IDeliveryAddressShippingCost>> =>
    await request.post(`${baseRoute}/${addressId}/shipping-cost`, payload),
};
